import { createSelector } from 'reselect';

const selectOpenNetworkRegistries = (state: any) => state.openNetworkRegistries;


export const selectOpenNetworkRegistriesCurrentItem = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.current);

export const selectOpenNetworkRegistriesListItems = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectOpenNetworkRegistriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpenNetworkRegistriesQueryItems = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.query);

export const selectOpenNetworkRegistriesCreatedItem = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.create);

export const selectOpenNetworkRegistriesUpdatedItem = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.update);

export const selectOpenNetworkRegistriesReadItem = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.read);

export const selectOpenNetworkRegistriesDeletedItem = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.delete);

export const selectOpenNetworkRegistriesSearchedItems = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.search);

export const selectOpenNetworkRegistriesItemsCount = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.count);

export const selectOpenNetworkRegistriesItemsFilter = createSelector([selectOpenNetworkRegistries], (openNetworkRegistries) => openNetworkRegistries.filter);